module.exports = __webpack_public_path__ + "img/rajdoot.9eb660b1.png";